import React, { PropsWithChildren } from "react";
//#region types
import { WidgetAreaProps } from "models/propTypes/widgetProps";
//#endregion
//#region components
import GridR from "../grid/responsiveGrid";
//#endregion
import clsx from "clsx";
import cssExports from "theme/styles/main.module.scss";

const WidgetArea: React.FC<PropsWithChildren<WidgetAreaProps>> = (props) => {
  return (
    <GridR container item className={clsx(cssExports.widget, props.className)} spacing={4}>
      {props.children}
    </GridR>
  );
};

export default WidgetArea;
